import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { IoChevronDown } from "react-icons/io5";
import cn from "../../../lib/cn";

const AccordionItem = ({
    title,
    children,
    isOpen,
    onToggle,
    icon,
    wrapperClassName,
}) => {
    let Icon = icon ? icon : IoChevronDown;

    return (
        <div
            className={cn(
                "border border-blue-250 rounded-sm mb-2",
                wrapperClassName
            )}
        >
            <button
                onClick={onToggle}
                className="w-full flex justify-between items-center p-1 text-left text-base font-medium  focus:outline-none"
            >
                {title}
                <Icon
                    className={`transition-transform duration-300 ${
                        isOpen ? "rotate-180" : "rotate-0"
                    }`}
                />
            </button>
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { height: "auto", opacity: 1 },
                            collapsed: { height: 0, opacity: 0 },
                        }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="overflow-hidden px-1"
                    >
                        <div className="py-1 text-gray-700 text-sm">
                            {children}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default AccordionItem;
